import React, { useEffect, useMemo, useState } from "react";
import { colorConstant } from "../../../../styles/colorConstant/colorConstant";
import { Box, Modal } from "@mui/material";
import PosCustomIcon from "../../../../customComponents/PosCustomIcon/PosCustomIcon";
import { FunnelIcon, MagnifyingGlassIcon, XMarkIcon } from "@heroicons/react/24/outline";
import "./OdsDeliveryTable.css";
import { DataGrid } from "@mui/x-data-grid";
import PosCustomerFilterV2 from "../../../../customComponents/PosCustomerFilterV2/PosCustomerFilterV2";
import { getStoreCurrencySymbol } from "../../../../utils/currency";

const style = {
  position: "absolute",
  top: "50%",
  right: "-45%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  height: "100%",
  bgcolor: `${colorConstant.surfaceWhite}`,
  padding: "1.5rem",
  borderTopLeftRadius: "12px",
  borderBottomLeftRadius: "12px",
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",
};

const OdsDeliveryTable = ({ isDeliveryModalOpen, setIsDeliveryModalOpen, deliveredModalData }) => {
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });

  const SALES_CHANNEL_MAP = {
    ZOMATO_ORDER: "Zomato",
    SWIGGY_ORDER: "Swiggy",
    RESTAURANT_ORDER: "Restaurant Order",
    DELIVERY: "Delivery",
    POS: "POS",
    ONLINE: "Online",
    WHATSAPP_ORDER: "Whatsapp",
    B2C_ORDER: "Website Order",
  };

  const columns = [
    { field: "customerName", headerName: "Cust Name", flex: 1, minWidth: 150 },
    { field: "mobileNumber", headerName: "Phone No", flex: 1, minWidth: 140 },
    {
      field: "salesChannel",
      headerName: "Source",
      flex: 1,
      minWidth: 140,
      valueGetter: (params) => SALES_CHANNEL_MAP[params.value] || "Other",
    },
    { field: "numberOfLineItems", headerName: "Items", width: 80 },
    { field: "orderId", headerName: "Order Id", flex: 1, minWidth: 170 },
    { field: "token", headerName: "KOT", width: 80 },
    {
      field: "grandTotal",
      headerName: "Value",
      width: 100,
      valueFormatter: ({ value }) => `${getStoreCurrencySymbol()}${value}`,
    },
    { field: "paymentMethod", headerName: "Payment Type", width: 130 },
  ];

  const rows = useMemo(() => {
    return deliveredModalData.map((item, index) => ({
      id: item.id || index,
      ...item.content,
    }));
  }, [deliveredModalData]);

  const handleOdsDeliveryClose = () => {
    setIsDeliveryModalOpen(false);
  };

  return (
    <Modal open={isDeliveryModalOpen} onClose={handleOdsDeliveryClose}>
      <Box sx={style}>
        <div className="odsDeliveryModalHeader">
          <div className="odsDeliveryModalLeft">
            <p className="odsDeliveryModalLeftText">All Delivery Orders</p>
            <div className="odsDeliveryOptionsInputWrapper">
              <PosCustomIcon
                icon={<MagnifyingGlassIcon />}
                color={"#6B6B6B"}
                height={"1.25rem"}
                width={"1.25rem"}
              />
              <input
                className={`odsDeliveryOptionsSearch`}
                type="text"
                placeholder="Search for orders"
                onChange={{}}
              />
            </div>
            {/* <PosCustomerFilterV2
              label="Filters"
              width="100%"
              border={"1px solid #D5D7DA"}
              backgroundColor="var(--surface-white)"
              fontSize="1rem"
              textColor="#252B37"
              lableFontWeight="500"
              iconsSize="1rem"
              padding="6px 12px"
              radius="4px"
            /> */}
          </div>
          <div className="odsDeliveryModalRight">
            <PosCustomIcon
              icon={<XMarkIcon />}
              height={"20px"}
              width={"20px"}
              color="var(--surface-g5)"
              pointer={true}
              onClickFunction={handleOdsDeliveryClose}
            />
          </div>
        </div>

        <div style={{ flex: 1, marginTop: "8px" }}>
          <DataGrid
            rows={rows}
            columns={columns}
            pagination
            page={paginationModel.page}
            pageSize={paginationModel.pageSize}
            onPageChange={(newPage) => setPaginationModel((prev) => ({ ...prev, page: newPage }))}
            onPageSizeChange={(newPageSize) =>
              setPaginationModel((prev) => ({ ...prev, pageSize: newPageSize }))
            }
            rowsPerPageOptions={[10, 20, 30]}
            disableRowSelectionOnClick
            disableColumnMenu
            sx={{
              border: "1px solid #DADDE3",
              borderRadius: "8px",
              overflow: "hidden",
              "& .MuiDataGrid-columnSeparator": {
                display: "none",
              },
              "& .MuiDataGrid-sortIcon": {
                display: "none",
              },
              "& .MuiDataGrid-columnHeader": {
                cursor: "default",
              },
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: "#E9EAEB",
              },
            }}
          />
        </div>
      </Box>
    </Modal>
  );
};

export default OdsDeliveryTable;
